import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';

import ShoesB from './svg/shoesB.svg?react';
import ShoesF from './svg/shoesF.svg?react';
import ShoesFH from './svg/shoesFH.svg?react';
import ShoesH from './svg/shoesH.svg?react';

const Root = styled.span`
  display: flex;
  align-items: center;
`;

const StyledBox = styled.div`
  line-height: 0;
  vertical-align: middle;

  svg {
    width: ${p => p.size}px;
    height: ${p => p.size}px;

    ${p =>
      p.changed &&
      `
      path {
        fill: ${colors.change};
        stroke: ${colors.change};
      }
    `}
  }
`;

const mapIcons = {
  B: ShoesB,
  F: ShoesF,
  FH: ShoesFH,
  H: ShoesH,
};

const ShoeSymbolValue = ({
  shoeId,
  shoes,
  isPreliminaryShoes,
  changed,
  size,
}) => {
  const Comp = mapIcons[shoeId];

  return (
    <Root>
      {isPreliminaryShoes && '('}
      <StyledBox size={size} changed={changed}>
        <Comp title={shoes} />
      </StyledBox>
      {isPreliminaryShoes && ')'}
    </Root>
  );
};

ShoeSymbolValue.propTypes = {
  shoeId: PropTypes.oneOf(['B', 'F', 'FH', 'H']).isRequired,
  shoes: PropTypes.string,
  isPreliminaryShoes: PropTypes.bool,
  changed: PropTypes.bool,
  size: PropTypes.number.isRequired,
};

export default ShoeSymbolValue;
